// src/routes/PrivateRoutes.tsx
import ErrorPage from 'components/ErrorBoundary/ErrorPage';
import { lazy, Suspense } from 'react';
import { Navigate } from 'react-router-dom';
import { RoutePaths } from 'types/Routes';
import Loading from '../components/Loading';
import ProtectedRoute from './ProtectedRoute';

const Layout = lazy(() => import('layouts'));
const Account = lazy(() => import('pages/account'));
const ActiveUser = lazy(() => import('pages/activeUser'));
const Faritany = lazy(() => import('pages/game/faritany'));
const Replay = lazy(() => import('pages/game/replay'));
const SpectateRound = lazy(() => import('pages/game/spectate'));
const Round = lazy(() => import('pages/game/round'));
const GameRules = lazy(() => import('pages/gameRules'));
const History = lazy(() => import('pages/history'));
const Notif = lazy(() => import('pages/notif'));

const PrivateRoutes = [
  {
    element: <ProtectedRoute />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: RoutePaths.HOME,
        element: (
          <Suspense fallback={<Loading />}>
            <Layout />
          </Suspense>
        ),
        children: [
          {
            path: '/',
            element: <Navigate to={RoutePaths.ROUND} />,
          },
          {
            path: RoutePaths.ROUND,
            element: (
              <Suspense fallback={<Loading />}>
                <Round />
              </Suspense>
            ),
          },
          {
            path: RoutePaths.NOTIF,
            element: (
              <Suspense fallback={<Loading />}>
                <Notif />
              </Suspense>
            ),
          },
          {
            path: RoutePaths.ACTIVE_USER,
            element: (
              <Suspense fallback={<Loading />}>
                <ActiveUser />
              </Suspense>
            ),
          },
          {
            path: RoutePaths.GAME_RULES,
            element: (
              <Suspense fallback={<Loading />}>
                <GameRules />
              </Suspense>
            ),
          },
          {
            path: RoutePaths.HISTORY,
            element: (
              <Suspense fallback={<Loading />}>
                <History />
              </Suspense>
            ),
          },
          {
            path: RoutePaths.ACCOUNT,
            element: (
              <Suspense fallback={<Loading />}>
                <Account />
              </Suspense>
            ),
          },
        ],
      },
      {
        path: RoutePaths.FARITANY,
        element: (
          <Suspense fallback={<Loading />}>
            <Faritany />
          </Suspense>
        ),
      },
      {
        path: '/replay/:roomName',
        element: (
          <Suspense fallback={<Loading />}>
            <Replay />
          </Suspense>
        ),
      },
      {
        path: RoutePaths.SPECTATE,
        element: (
          <Suspense fallback={<Loading />}>
            <SpectateRound />
          </Suspense>
        ),
      },
    ],
  },
];

export default PrivateRoutes;
